import { render, staticRenderFns } from "./newPartList.vue?vue&type=template&id=7cd56c99&scoped=true"
import script from "./newPartList.vue?vue&type=script&lang=js"
export * from "./newPartList.vue?vue&type=script&lang=js"
import style0 from "./newPartList.vue?vue&type=style&index=0&id=7cd56c99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd56c99",
  null
  
)

export default component.exports